import { render } from "./TravelCards.vue?vue&type=template&id=38ab07e2"
import script from "./TravelCards.vue?vue&type=script&lang=js"
export * from "./TravelCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__